module.exports = __webpack_public_path__ + "img/email.af4f8d46.svg";